import {createSelector} from 'reselect'

import api from '../../../common/api.js'
import ConfirmModal from '../../../common/components/Modal/ConfirmModal.js'
import {showMessageToast} from '../../Header/Toast/index.js'
import {goToShipperSettings} from './ShippersFunctions.js'
import {setShipper, shipperSelector} from '../../../data/shippers.js'
import {formsSelector} from '../../../redux/selectors/ui/forms.js'
import {
  getState,
  onlyIfForm,
  removeForm,
  setForm,
  updateForm,
  useSelector,
} from '../../../store.js'

export const MODAL_FORM = 'archive_shipper_modal'

export function showArchiveShipperModal(shipperID) {
  setForm(MODAL_FORM, {
    shipperID,
    isSaving: false,
    serverError: null,
  })
}

export function updateModalForm(...args) {
  updateForm(MODAL_FORM, ...args)
}

export function closeModal() {
  removeForm(MODAL_FORM)
}

export const modalFormSelector = createSelector(
  formsSelector,
  (forms) => forms[MODAL_FORM],
)

export async function archiveShipper() {
  try {
    const {shipperID} = modalFormSelector(getState())
    const shipper = shipperSelector(getState(), {shipperID})

    updateModalForm({isSaving: true, serverError: null})

    const {json} = shipper.archive_date
      ? await api.put(`/shipper/${shipperID}/`, {archive_date: null})
      : await api.delete(`/shipper/${shipperID}/`)

    goToShipperSettings()

    setShipper(json)

    closeModal()

    showMessageToast(
      `${shipper.archive_date ? 'Unarchived' : 'Archived'} carrier`,
    )
  } catch (err) {
    updateModalForm({
      serverError: err.message || err.error_message,
      isSaving: false,
    })
  }
}

function ArchiveShipperModal({form}) {
  const shipper = useSelector((state) =>
    shipperSelector(state, {
      shipperID: form.shipperID,
    }),
  )

  return (
    <ConfirmModal
      title={`${
        shipper.archive_date ? 'Unarchive' : 'Archive'
      } Carrier Account`}
      modalSize="sm"
      onConfirm={() => archiveShipper()}
      onCancel={() => closeModal()}
      confirmText="Yes"
      cancelText="No"
      isSaving={form.isSaving}
      error={form.serverError}
    >
      <div className="fs-01"></div>
      <div className="fs-01 margin-bottom-5">
        <span>
          Are you sure you want to {shipper.archive_date ? 'un' : ''}archive{' '}
          <strong>{shipper.name}</strong>?
        </span>
      </div>
    </ConfirmModal>
  )
}

export default onlyIfForm(ArchiveShipperModal, modalFormSelector)
